import CallApp from 'callapp-lib'
import { UIUtil } from './UIUtil'
import { EnvUtil } from './EnvUtil'
import { HtmlUtil } from './HtmlUtil'
import { DateUtil } from './DateUtil'
import { StringUtil } from './StringUtil'
import { AppVersion } from './AppVersion'
import { StorageUtil } from './StorageUtil'
import { BrowserUtil } from './BrowserUtil'
import { JSBridgeUtil } from './JSBridgeUtil'
import { EventEmitter } from './EventEmitter'
import { HttpUtil, HttpUtilMethod } from './HttpUtil'
import {
  IADConfig,
  IIntelligentClassClientMsg,
  IIntelligentClassDrillMsg,
  IIntelligentClassSocketMsg,
} from 'kuaidong-model'
import { AppJumpUtil, AppNativePageName, redirectMap } from './AppJumpUtil'

export * from './AppJumpUtil'

/**
 * 和native app的util方法
 */
let callApp: CallApp
let deviceInfo: IDeviceInfo | null = null
let requestToken = ''
let isUnderAppResult: boolean | null = null

const RequestTokenKey = 'rtk'

export const RequestTokenQueryKey = '__rtqk__'

export enum AppUtilEvent {
  Auth = 'Auth',
  Login = 'Login',
  Resize = 'Resize',
  WebviewActive = 'WebviewActive',
  WebviewInactive = 'WebviewInactive',
  // 返回数据 {"mode":"success", "province": string, city: string, district: string}
  LocationCallback = 'locationCallback',
  rechargeSuccess = 'rechargeSuccess',
}

type _OpenDownloadOption = {
  jumpCfg?: any
  commandName?: string
  commandValue?: string | number
  qd?: string // 下载渠道
  tsChannel?: string
}

export interface IAppFriend {
  url: string
  head_img_url: string
  level_no: string
  nick_name: string
  user_id: string
  update_ts: number
  last_msg_ts: number
  member_type: string // 非会员 | 普通会员 | 大会员
  use_decoration: string
  is_pure_enjoy: boolean
  member_growth_level: number
}

export interface IDeviceInfo {
  ['X-Gkid-flavor']: string
  ['X-Gkid-appVersion']: string
  ['X-Gkid-deviceType']: string
  ['X-Gkid-deviceName']: string
  ['X-Gkid-wakeup-id']: string // 语音唤醒设备id
  ['X-Gkid-deviceId']: string // 体锻屏设备id
}

export interface IAppReminderParams {
  title: string
  description: string
  startDate: Date
  endDate: Date
  repeatMode: 0 | 1 | 2 // 仅一次 | 每天 | 每月
}

export interface IAppPurchaseParams {
  refer?: string
  sku_code?: string
  scene_id1?: string
  scene_id2?: string
  resource_id?: string
  promotion_code?: string // IOS only
}

export interface IBackInterceptorParams {
  canGoBack: boolean
}

/** 调起 App 摄像头直播（RTC）入参 */
export interface IStartRtcRoomParams {
  app_id: string
  room_id: string
  user_id: string
  token: string
}

export interface IAudioWakeupCallbackParams {
  code: number // 0-关闭；1-开启；2-唤醒成功；<0-异常
  status: 'close' | 'open' | 'success' | 'error'
  data: Record<string, any>
}

interface IStartDrillParams {
  ext_infos?: {
    navigate?: 'buildFace' | 'dressup'
    select_item?: string
    select_page?: string
    island_user_id?: string
    event_id?: string
    event_type?: string
  }
  sticker_id?: string // 贴纸id
  need_record?: 0 | 1
  record_type?: number // 1 需要尽量强制录视频
  hide_advertise?: boolean
  is361Competition?: boolean
  forbid_countdown?: 0 | 1
  drill_mode?: 'realtime' // 是否实时控制drill,与AppUtil.drillPlaySend、drillPlayReciveRegist配合使用
  skipDetect?: boolean // 是否跳过校准, realtime模式下使用
  skip_to_go?: boolean // 是否跳过校准后直接进入游戏，仅当skipDetect=true时候生效，true：直接进入游戏；false：跳过校准后等待老师发送指令后才进入游戏
  gamedata_interval?: number // 游戏数据回传间隔，如果有，则按照给定，否则默认值500ms, realtime模式下使用
  filter_skeleton?: boolean // 如果true，则过滤骨骼点，否则默认传骨骼点, realtime模式下使用
  single_leg_percent?: number // 规定双脚跳，如果出现单双脚跳的概率大于这个值（比率）， 整数， 则认为单双脚跳
  plate_number_bg_url?: string // 比赛号码牌的背景图
  show_athlete_prepare?: boolean // 是否有运动员准备开屏提示
  game_config?: string // drill game_config, json需要stringify
  check_video_upload?: number // 是否要上传检测原始视频，0或1，默认0
}

export class AppUtil {
  static eventEmitter = new EventEmitter()

  // 打开app所需的命令, 文档见 https://www.tapd.cn/61308320/documents/show/1161308320001001727
  static AppOpenCmd = {
    battle: 'C', // drill挑战，  NOTE 没有 'ts://' 前缀 其他都有
    joinClass: 'J', // 加入班级
    liveSeries: 'L', // 直播系列课打开
    liveShareCourse: 'S', // 直播课程分享
    qudao: 'Q', // 渠道的cmd
    channelKey: 'ts_channel', // 渠道query里的参数
    _OldCmds: ['C', 'J'], // 老的命令
    _CmdPrefix: 'G-', // 命令的前缀
    _SplitMultiCmd: '###', // 多个命令的分割线
    _SplitCmd: '##', // 单个命令cmd和value的区分
    _IosCommandPrefix: '1 https://www.tiantiantiaosheng.com/app?', // ios匹配又是数字，又是链接
  }

  public static ContactWay = {
    CustomerServicePagePath: '/contact-us', //联系客服页面路径
    CustomerServicePhone: '021-38279915', // 联系电话
    WechatRedirectPageUrl: 'https://work.weixin.qq.com/kfid/kfcc2222f966ea0e6f5', // 用了小倩的, 基本体智云在用
    // 废弃了 使用 api里的AKf 仅处理支付问题客服
    WechatUrlForPayment: 'https://work.weixin.qq.com/kfid/kfc709fce2064867e92',
    // 废弃了 使用 api里的AKf 天天跳绳app客服
    WechatUrlForAPP: 'https://work.weixin.qq.com/kfid/kfc800cee2b57184b8a',
    WechatUrlForTzy: 'https://work.weixin.qq.com/kfid/kfc9dea80c2ad77fa71', // 处理体智云的， 老黄的地址
  }

  public static async init() {
    if (await this.isUnderApp()) {
      this._addAppCallListener('becomeActive', () => {
        this.eventEmitter.fire(AppUtilEvent.WebviewActive)
      })
      this._addAppCallListener('enterBackground', () => {
        this.eventEmitter.fire(AppUtilEvent.WebviewInactive)
      })
      this._addAppCallListener('locationCallback', (v: { province: string; city: string; district: string }) => {
        this.eventEmitter.fire(AppUtilEvent.LocationCallback, this._parseRespData(v))
      })
      this._addAppCallListener('rechargeSuccess', (v: { count: number }) => {
        this.eventEmitter.fire(AppUtilEvent.rechargeSuccess, this._parseRespData(v))
      })
    } else {
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          this.eventEmitter.fire(AppUtilEvent.WebviewActive)
        }
        if (document.visibilityState === 'hidden') {
          this.eventEmitter.fire(AppUtilEvent.WebviewInactive)
        }
      })
    }
  }

  public static on(type: AppUtilEvent, handler: Function) {
    this.eventEmitter.on(type, handler)
  }

  public static once(type: AppUtilEvent, handler: Function) {
    this.eventEmitter.once(type, handler)
  }

  public static fire(type: AppUtilEvent) {
    this.eventEmitter.fire(type)
  }

  public static remove(type: AppUtilEvent, handler?: Function) {
    this.eventEmitter.remove(type, handler)
  }

  public static keepActive() {
    return AppUtil.isUnderApp().then((res) => {
      if (res) {
        return AppUtil.callGetAppVersion()
      }
    })
  }

  public static buildRequestTokenKey() {
    return `__${EnvUtil.appName()}_${RequestTokenKey}__`
  }

  public static setRequestToken(_token: string) {
    requestToken = _token

    if (BrowserUtil.isWeapp() || EnvUtil.isApph5()) {
      StorageUtil.set(this.buildRequestTokenKey(), _token, 24 * 3600 * 30)
    } else {
      StorageUtil.set(this.buildRequestTokenKey(), _token, 24 * 3600 * 30)
    }
  }

  public static getRequestToken() {
    if (!requestToken) {
      requestToken = StorageUtil.get(this.buildRequestTokenKey()) || ''
    }

    return requestToken
  }

  public static async removeRuquestToken() {
    this.setRequestToken('')
  }

  // 判断用户是否已经登录
  public static async isNotLogin(): Promise<boolean> {
    if (await this.isUnderApp()) {
      return false // app下固定是登录的
    }
    return !this.getRequestToken() // 没有token说明没登录
  }

  // app内发起get请求，会带上当前登录用的token信息，登录状态
  public static async httpGET(
    url: string,
    params = {},
    headers = {},
    skipEventEmitter = true,
    withCredentials: boolean | undefined = undefined
  ): Promise<any> {
    headers = await this._appendRequestHeaders(headers, this._checkIsNeedAppendDeviceInfo(url))

    return HttpUtil.request(HttpUtilMethod.Get, url, params, headers, skipEventEmitter, withCredentials)
  }

  // app内发起请求，请求的是体智云服务器
  public static async httpTzyGET(
    url: string,
    params = {},
    headers = {},
    skipEventEmitter = true,
    withCredentials: boolean | undefined = undefined
  ): Promise<any> {
    url = `${process.env.VUE_APP_CRAZYROPE_MANAGE_API}${url}`
    return this.httpGET(url, params, headers, skipEventEmitter, withCredentials)
  }

  // 同 httpGET 方法
  public static async httpPUT(
    url: string,
    params = {},
    headers = {},
    skipEventEmitter = false,
    withCredentials: boolean | undefined = undefined
  ): Promise<any> {
    headers = await this._appendRequestHeaders(headers, this._checkIsNeedAppendDeviceInfo(url))

    return HttpUtil.request(HttpUtilMethod.Put, url, params, headers, skipEventEmitter, withCredentials)
  }

  // 同 httpGET 方法
  public static async httpPOST(
    url: string,
    params = {},
    headers = {},
    skipEventEmitter = false,
    withCredentials: boolean | undefined = undefined
  ): Promise<any> {
    headers = await this._appendRequestHeaders(headers, this._checkIsNeedAppendDeviceInfo(url))

    return HttpUtil.request(HttpUtilMethod.Post, url, params, headers, skipEventEmitter, withCredentials)
  }

  public static async httpPOSTSSE(
    url: string,
    params = {},
    headers = {},
    config = {},
    withCredentials: boolean | undefined = undefined
  ): Promise<any> {
    headers = await this._appendRequestHeaders(headers, this._checkIsNeedAppendDeviceInfo(url))

    return HttpUtil.postStream(url, params, headers, config, true, withCredentials)
  }

  // 发送POST请求，处理每行流数据
  public static async httpPOSTSSEWithLineHandler(
    _url: string,
    _params = {},
    _headers = {},
    _config = {},
    _onLine: (_line: string) => void,
    _onEnd: () => void,
    _withCredentials: boolean | undefined = undefined
  ): Promise<void> {
    try {
      const res = await this.httpPOSTSSE(_url, _params, _headers, _config, _withCredentials)
      const reader = (res.data as ReadableStream).pipeThrough(new TextDecoderStream()).getReader()

      // eslint-disable-next-line no-constant-condition
      while (true) {
        const { value, done } = await reader.read()
        if (done) {
          _onEnd()
          break
        }

        const lines = value.split('data:')
        for (let i = 0; i < lines.length; i++) {
          if (lines[i]) {
            _onLine(lines[i])
          }
        }
      }
    } catch (e) {
      console.error('httpPOSTSSEStream error:', e)
    }
  }

  // httpTzyGET 方法
  public static async httpTzyPOST(
    url: string,
    params = {},
    headers = {},
    skipEventEmitter = false,
    withCredentials: boolean | undefined = undefined
  ): Promise<any> {
    url = `${process.env.VUE_APP_CRAZYROPE_MANAGE_API}${url}`
    return this.httpPOST(url, params, headers, skipEventEmitter, withCredentials)
  }

  public static async httpDelete(
    url: string,
    params = {},
    headers = {},
    skipEventEmitter = false,
    withCredentials: boolean | undefined = undefined
  ): Promise<any> {
    headers = await this._appendRequestHeaders(headers, this._checkIsNeedAppendDeviceInfo(url))

    return HttpUtil.request(HttpUtilMethod.Delete, url, params, headers, skipEventEmitter, withCredentials)
  }

  public static async httpCache<T extends (...args: any) => any>(fun: T, ...params: any[]) {
    let result: ReturnType<T>

    const key = `__${fun.name}_http_cache_key_${JSON.stringify(params)}__`

    const data = sessionStorage.getItem(key)

    if (data) {
      result = JSON.parse(data)
    } else {
      result = await fun.bind(AppUtil)(...params)

      sessionStorage.setItem(key, JSON.stringify(result))
    }

    return result
  }

  public static async httpQuery<T extends (..._args: any[]) => any>(
    _fun: T,
    _times = 3,
    _interval = 2000,
    _asset: (_result: Awaited<ReturnType<T>>) => boolean,
    ..._params: any[]
  ): Promise<ReturnType<T>> {
    try {
      const result = await _fun(..._params)

      if (_asset(result) || _times <= 1) {
        return result
      }

      await DateUtil.sleep(_interval)

      return this.httpQuery(_fun, _times - 1, _interval, _asset, ..._params)
    } catch (e) {
      if (_times <= 0) {
        throw e
      }

      await DateUtil.sleep(_interval)

      return this.httpQuery(_fun, _times - 1, _interval, _asset, ..._params)
    }
  }

  /**
   * 跳转url到新的页面，如果浏览器就打开新页面
   * 如果app内，需要放到返回堆栈里
   * @param url string 前往的url
   */
  public static async jumpUrlNewTab(url: string, title?: string) {
    if (await this.isUnderApp()) {
      this.jump2NativeURL(url, title)
    } else {
      BrowserUtil.isWechat() ? (location.href = url) : window.open(url, '_blank')
    }
  }

  public static async jumpToNewTab(path: string, title?: string) {
    AppUtil.jumpUrlNewTab(`${location.protocol}//${location.host}${location.pathname}${path}`, title)
  }

  public static async jumpToNewByRoutePath(path: string, title?: string) {
    AppUtil.jumpUrlNewTab(`${location.protocol}//${location.host}${location.pathname}#/${path}`, title)
  }

  public static async isUnderApp(): Promise<boolean> {
    if (isUnderAppResult === null) {
      isUnderAppResult = await this.checkIsUnderApp()
    }

    return isUnderAppResult
  }

  public static async checkIsUnderApp(): Promise<boolean> {
    if (BrowserUtil.isUnderApp()) {
      return true
    }

    // eslint-disable-next-line
    return new Promise(async (resolve) => {
      setTimeout(() => {
        resolve(false)
      }, 1000)

      try {
        await this.getUserToken()

        resolve(true)
      } catch (e) {
        resolve(false)
      }
    })
  }

  public static openAppAndgotoDL(qd?: string, app?: any) {
    // TODO try open app
    let url = 'https://www.tiantiantiaosheng.com/dl'
    if (app === 'tzy') url = 'https://www.tizhiyun.com/dl'

    location.href = url + (qd ? `?qd=${qd}` : '')
  }

  /**
   * 判断是否是大屏
   */
  public static async isUnderTV() {
    if (await this.isUnderApp()) {
      const deviceInfo = await this.getDeviceInfo()

      return (
        deviceInfo['X-Gkid-deviceName']?.toLowerCase() === 'harmonyos' &&
        deviceInfo['X-Gkid-deviceType']?.toLowerCase() === 'tv'
      )
    }

    return false
  }

  /**
   * 确定是否在ios下
   */
  public static async isUnderIos(): Promise<boolean> {
    if (await this.isUnderApp()) {
      return BrowserUtil.isIOS()
    }

    return false
  }

  public static async isUnderAndroid(): Promise<boolean> {
    if (await this.isUnderApp()) {
      return BrowserUtil.isAndroid()
    }

    return false
  }

  /**
   *
   * @param link 页面链接
   * @param title 分享卡片标题
   * @param desc 分享卡片描述
   * @param img 分享卡片图片
   * @returns
   */
  public static async shareLink(
    link: string,
    title: string,
    desc: string,
    _base64Img: string,
    _params?: {
      buttonTitle?: string
      hasAppShare?: boolean
    },
    _cb?: (_data: IAppFriend | null) => void
  ): Promise<void> {
    _cb && this._addAppCallListener('shareLinkCallback', (_params: any) => _cb(JSON.parse(_params).data))

    return JSBridgeUtil.asyncCall('shareLink', {
      link,
      title,
      desc,
      thumb: _base64Img,
      ...(_params || {}),
    })
  }

  public static async pickFriend(
    _params: { activityId: string; buttonTitle: string },
    _cb?: (_data: IAppFriend | null) => void
  ) {
    if (!(await this.isAppVersionHigherThan('4.0.55'))) {
      this.openNativePage('never', undefined, true)
      return
    }

    _cb && this._addAppCallListener('pickFriendCallback', (_params: any) => _cb(JSON.parse(_params).data))

    return JSBridgeUtil.asyncCall('pickFriend', _params)
  }

  /**
   * 在系统浏览器打开
   * @param url 打开的地址
   * @returns
   */
  public static async startSystemBrowser(url: string) {
    return JSBridgeUtil.asyncCall('openBrowser', {
      url,
    })
  }

  public static async startDrillWithParams(
    drillId: string,
    params: IStartDrillParams & {
      eventType?: string
      eventId?: string
      plateNumber?: string
      reloadCB?: (drillRecord: string, ...args: any[]) => void
    } = {}
  ) {
    const eventType = params.eventType || ''
    const eventId = params.eventId || ''
    const plateNumber = params.plateNumber || ''
    const reloadCB = params.reloadCB || undefined
    return this.startDrill(drillId, eventType, eventId, plateNumber, reloadCB, params)
  }

  /**
   *
      {
        response: {
          record_id: string
          score: number
          drill_intro: {
            name: string // drill id
            display_name: string // drill 中文名
          }
        }
      }
   */
  public static async startDrill(
    drillId: string,
    eventType = '',
    eventId = '',
    plateNumber = '', // 比赛的号码牌
    reloadCB?: (drillRecord: string) => void, // 完成之后的回调， 传参 need_record = 1 的时候会给出drill相关数据, const result: { response: IDrillRecord } = JSON.parse(_result)
    params: IStartDrillParams = {}
  ) {
    if (eventType === 'sports_work') {
      // 体育运动任务来的，直接跳过广告，校准页的广告
      params['hide_advertise'] = true
    }

    if (reloadCB) {
      this._addAppCallListener('reloadCallback', reloadCB)
    }
    console.log('startDrill', drillId, eventType, eventId, plateNumber, params)

    return JSBridgeUtil.asyncCall('startDrill', {
      drill_id: drillId,
      event_type: eventType,
      event_id: eventId,
      plate_number: plateNumber,
      show_athlete_prepare: params.show_athlete_prepare || (eventType === 'online_match' && !!plateNumber),
      ...params,
    })
  }

  public static async startMultiDrill(
    event_type: string,
    event_id: string,
    need_detect: boolean,
    drills: any[],
    cb?: (res: { response: any[] }) => any
  ) {
    if (cb) {
      this._addAppCallListener('recordCallback', cb)
    }

    return JSBridgeUtil.asyncCall('startMultiDrill', {
      event_type,
      event_id,
      need_detect,
      drills,
    })
  }

  public static async watchADVideo(
    ids: IADConfig[],
    callBack?: (val: { status: 'show' | 'failed' | 'reward' | 'dismiss' }) => any
  ) {
    const platform = BrowserUtil.isHarmony() ? 'harmony' : (await this.isUnderAndroid()) ? 'android' : 'ios'

    const tobid = ids.find((id) => id.channel === 'tobid' && id.app_platform === platform)
    const gromore = ids.find((id) => id.channel === 'gromore' && id.app_platform === platform)

    if (tobid && (gromore || BrowserUtil.isHarmony())) {
      return this.watchRewardVideo(tobid.ad_id, gromore?.ad_id || '', callBack)
    }

    throw Error('Wrong ad config.')
  }

  public static async watchRewardVideo(
    tobid_id: string,
    gromore_id: string,
    callBack?: (val: { status: 'show' | 'failed' | 'reward' | 'dismiss' }) => any
  ) {
    if (callBack) {
      this._addAppCallListener('rewardVideoCallback', (str: any) => callBack(JSON.parse(str)))
    }

    return JSBridgeUtil.asyncCall('startLoadingRewardVideo', { tobid_id, gromore_id })
  }

  public static readonly PracticeDrillId = 'home_practice_move_2105'

  public static async startPractice(
    video_url: string,
    video_size: string,
    key_frame_url: string,
    key_frame_video_width: number,
    key_frame_video_height: number,
    drill_orientation: string,

    reloadCB?: Function,
    // need_record = true时会有参数回调
    params: { need_record?: boolean; drill_id?: string } = { need_record: true }
  ) {
    if (reloadCB) {
      this._addAppCallListener('reloadCallback', reloadCB)
    }
    // 默认使用跟练模式
    const drill_id = params.drill_id || this.PracticeDrillId

    const startPracticeParams = {
      drill_id,
      video_url,
      video_size,
      key_frame_url,
      key_frame_video_width,
      key_frame_video_height,
      drill_orientation,
      ...params,
    }
    console.log('AppUtil.asyncCall', 'startPractice', startPracticeParams)
    return JSBridgeUtil.asyncCall('startPractice', startPracticeParams)
  }

  public static async challenge(token: string): Promise<string> {
    return JSBridgeUtil.asyncCall('challenge', token)
  }

  /**
   * 上传学生照片（调用原生拍照）
   * @returns { image_url: string } 照片 URL
   */
  public static async uploadStudentPhoto(): Promise<{ image_url: string }> {
    return new Promise((resolve) => {
      this._addAppCallListener('onStudentPhotoUpload', (resp: string) => {
        resolve(JSON.parse(resp))
      })
      JSBridgeUtil.asyncCall('uploadStudentPhoto')
    })
  }

  /**
   * 体锻屏登录账号登出
   */
  public static async logoutFitScreenAccount(): Promise<void> {
    return JSBridgeUtil.asyncCall('logoutAccount')
  }

  /**
   * 从本地选择视频，并生成骨骼点，生成骨骼点osskey和 video key
   */
  public static async startSkeletonVideo(
    options: {
      cb?: (res: { type: 'drill' | 'video'; video_file: string; skeleton_file: string; record_id?: string }) => void
    } = {}
  ): Promise<void> {
    if (options && options.cb) {
      this.addSkeletonVideoCallback(options.cb)
    }
    return JSBridgeUtil.asyncCall('startSkeletonVideo')
  }

  /**
   * 调用drill开始拍摄，带骨骼点的视频
   */
  public static async startRecordSkeletonVideo(
    drillId = 'movement_compare_skeleton_video_shoot', // 固定是这个drill
    options: {
      cb?: (res: { type: 'drill' | 'video'; video_file: string; skeleton_file: string; record_id?: string }) => void
    } = {}
  ) {
    if (options && options.cb) {
      this.addSkeletonVideoCallback(options.cb)
    }
    return this.startDrill(drillId)
  }

  /**
   * 拍摄视频或者上传视频后生成骨骼点和视频信息
   */
  public static async addSkeletonVideoCallback(
    cb: (res: {
      type: 'drill' | 'video' // 通过drill拍摄的，还是上传视频生成的
      video_file: string // 视频osskey
      skeleton_file: string // 骨骼点文件osskey
      record_id?: string // 如果是通过drill拍摄的，才会有record_id
      canvas_width?: number
      canvas_height?: number
      skeleton_begin_time?: number // 骨骼点首帧时间戳
    }) => void
  ) {
    this._addAppCallListener('skeletonVideoResult', (resp: string) => {
      cb(JSON.parse(resp))
    })
  }

  public static async buildDictByName(
    _name: AppNativePageName
  ): Promise<ReturnType<typeof AppJumpUtil.buildDictByName>> {
    return AppJumpUtil.buildDictByName(await this.getNativePageName(_name))
  }

  public static async getNativePageName(_name: AppNativePageName): Promise<AppNativePageName> {
    const redirectItem = redirectMap[_name]
    if (redirectItem && (await this.isAppVersionHigherThan(redirectItem.version))) {
      return this.getNativePageName(redirectItem.target)
    }

    return _name
  }

  public static async jump2UserSportsSpace(userID: string) {
    const page = AppJumpUtil.buildDictByName('personalSportsSpace')
    page.iOS_param = { userID }
    page.Android_param = { 'clsmate.id': userID }
    return this.jump2NativePage(page)
  }

  /**
   * H5退回到APP
   */
  public static async backToApp(_quitAfterAction: boolean | null = false): Promise<string> {
    if (_quitAfterAction && (await this.isUnderIos())) {
      return JSBridgeUtil.asyncCall('removeSelf')
    }

    return JSBridgeUtil.asyncCall('finish')
  }

  public static async closeCurrentPage(): Promise<string> {
    return this.backToApp()
  }

  // 隐藏app的 title Bar
  public static async hideAppTitleBar(): Promise<any> {
    return JSBridgeUtil.asyncCall('hideTitleBar').then((_res) => {
      this.eventEmitter.fire(AppUtilEvent.Resize)
      return _res
    })
  }

  // 隐藏底部的bar
  public static async callHideBottomBar(state: 'show' | 'hide' = 'hide'): Promise<any> {
    // 参数为"show" 或者 "hide"
    return JSBridgeUtil.asyncCall('setNativeViewVisibility', state)
  }

  public static async callShowBottomBar(): Promise<any> {
    return this.callHideBottomBar('show')
  }

  public static async isAppVersionHigherThan(version: string) {
    const curVersion = this._parseRespData(await this.callGetAppVersion()).version_name
    console.log('curVersion', curVersion, version)

    return AppVersion.isEqualOrHigherThan(curVersion, version)
  }

  public static async callGetAppVersion(): Promise<{ version_name: string; flavor_market?: string }> {
    // {"version_name":"1.1.8"}
    return JSBridgeUtil.asyncCall('getAppVersion')
  }

  // 版本 1.1.8 变成 10108
  public static async callGetAppVersionNumber(): Promise<number> {
    try {
      const resp = this._parseRespData(await this.callGetAppVersion())
      const items = resp.version_name.split('.')
      if (items.length !== 3) {
        return 0
      } else {
        return parseInt(items[0]) * 10000 + parseInt(items[1]) * 100 + parseInt(items[2])
      }
    } catch (e) {
      // eslint-disable-next-line
      console.error(e)
      return 0
    }
  }

  // 判断版本是否高于某个版本 >=
  public static async checkVersionGte(checkVersion: number) {
    return (await this.callGetAppVersionNumber()) >= checkVersion
  }

  /**
   * 让app下某个url的内容, 下载完成之后有回调，回调方法为 downloadCallback
   * @param url 需要下载的url， 图片或者视频
   */
  public static async downloadByUrl(url: string, downloadCB?: Function): Promise<any> {
    if (!downloadCB) {
      downloadCB = (args: any) => {
        // {url: string, message?: string, result: string, filePath?: string }
        // eslint-disable-next-line
        console.log(`========done callback default ${args}`)
      }
    }
    this._addAppCallListener('downloadCallback', downloadCB)
    return JSBridgeUtil.asyncCall('download', url)
  }

  /**
   * 让app下某个url的内容, 然后掉系统分享出去
   * @param url 需要下载的url， excel文件等等
   */
  public static async downloadAndShareByUrl(url: string, downloadCB?: Function): Promise<any | { version: string }> {
    const version = '1.1.14'

    if (await this.isUnderApp()) {
      if (await this.isAppVersionHigherThan(version)) {
        if (!downloadCB) {
          downloadCB = (args: any) => {
            // {url: string, message?: string, result: string, filePath?: string }
            // eslint-disable-next-line
            console.log(`========done downloadV2 default ${args}`)
          }
        }

        this._addAppCallListener('downloadV2Callback', downloadCB)
        // ios会将文件进行编码，所以需要解码
        const isIos = await this.isUnderIos()
        if (isIos) {
          try {
            url = decodeURIComponent(url)
          } catch (e) {
            // eslint-disable-next-line
            console.error(e)
          }
        }
        return JSBridgeUtil.asyncCall('downloadV2', url)
      }

      return { version }
    } else {
      location.href = url
    }
  }

  /**
   * 同downloadByUrl，下载完成之后回调
   */
  public static async asyncDownloadByUrl(url: string): Promise<any> {
    return new Promise((resolve) => {
      this._addAppCallListener('downloadCallback', (resp: any) => {
        resolve(resp)
      })
      JSBridgeUtil.asyncCall('download', url)
    })
  }

  /**
   * 跳转参数参考：
   <a href="gkid://com.gkid.crazyrope/commonjump?para=%7b%22action%22%3a%22jump%22%2c%22Android_page%22%3a%22com.gkid.crazyrope.ui.home.HomeActivity%22%2c%22Android_param%22%3a%7b%22mode%22%3a%22challenge%22%2c%22token%22%3a%22xxxxxx%22%7d%7d">挑战天天跳绳</a>
   */
  public static async getUserToken(): Promise<string> {
    const result = await JSBridgeUtil.asyncCall('getUserToken')
    return result
  }

  public static async getLocalScreenRecord(recordId: string): Promise<string> {
    const result = await JSBridgeUtil.asyncCall('getLocalScreenRecord', recordId)
    BrowserUtil.log(`getLocalScreenRecord ${result} by ${recordId}`)
    return result
  }

  // 上传本地视频
  public static async uploadLocalVideo(recordId: string): Promise<boolean> {
    BrowserUtil.log(`uploadLocalVideo by ${recordId}`)
    const result = await JSBridgeUtil.asyncCall('uploadLocalVideo', recordId)
    BrowserUtil.log(`uploadLocalVideo ${result} by ${recordId}`)
    return result
  }

  public static async getVideoPreviewImage(recordId: string): Promise<string> {
    const result = await JSBridgeUtil.asyncCall('getVideoPreviewImage', recordId)
    return result
  }

  // 加入班级等操作后清空班级信息
  public static async userInfoUpdate() {
    try {
      if (await this.isUnderApp()) {
        await JSBridgeUtil.asyncCall('userInfoUpdate')
        return true
      } else {
        return false
      }
    } catch (e) {
      console.error(e)
      return false
    }
  }

  // NOTE 这功能有问题，别用了！！ 使用 wxshareBase64Img app端保存图片到本地
  public static async saveBase64Img(base64Img: string) {
    const result = await JSBridgeUtil.asyncCall('saveImage', {
      image: base64Img,
    })

    return result
  }

  // 尝试恢复户外跑中断，如果有中断，会弹出原生提示框， 返回true， 否则返回false
  public static async resumeOutdoorRunningInterrupt(): Promise<boolean> {
    console.log('resumeOutdoorRunningInterrupt start')
    const result = await JSBridgeUtil.asyncCall('outdoorRunInterruptEvent')
    console.log(`resumeOutdoorRunningInterrupt finish ${result}`)
    return result
  }

  // 通过微信分享图片
  // scene: session分享给好友,timeline朋友圈
  public static async wxshareBase64Img(base64Img: string, scene = 'session') {
    console.log(`wxshareBase64Img image size ${base64Img.length / 1024}K}`)
    const result = await JSBridgeUtil.asyncCall('share', {
      scene: scene,
      type: 'image/web',
      image: base64Img,
    })
    return result
  }

  public static async getUserData(): Promise<{
    phone: string
    user_no: number
    token: string
    user_id: string
  }> {
    try {
      return JSON.parse(await JSBridgeUtil.asyncCall('getUserData'))
    } catch (e) {
      return {
        token: '',
        phone: '',
        user_id: '',
        user_no: -1,
      }
    }
  }

  public static async getDeviceInfo(): Promise<IDeviceInfo> {
    if (!deviceInfo) {
      // 1秒钟，没有返回则返回空, 处理体智云app没有实现的逻辑
      const timeout = new Promise<string>((resolve) => setTimeout(() => resolve('{}'), 1000))
      deviceInfo = JSON.parse(await Promise.race([timeout, JSBridgeUtil.asyncCall('getDeviceInfo')]))
    }

    return deviceInfo!
  }

  // 判断给定userId是否是当前给用户
  public static async isCurrentUser(userId: string): Promise<boolean> {
    if (await this.isUnderApp()) {
      const userData = await this.getUserData()
      return userData.user_id === userId
    }
    return false
  }

  public static async selectAvatar(cb: (url: string) => void) {
    this._addAppCallListener('selectAvatarComplete', cb)

    return JSBridgeUtil.asyncCall('selectAvatar')
  }

  public static async getNetworkType(): Promise<'wifi' | 'no_wifi'> {
    if (await this.isUnderApp()) {
      return JSBridgeUtil.asyncCall('checkWifiState')
    }

    return (navigator as any)?.connection?.type || 'wifi'
  }

  public static async recharge(channel = ''): Promise<any> {
    // 废弃，之前是app内跳跳币充值的，现改为会员充值
    /*
    if (await this.isAppVersionHigherThan('2.0.22'))
      return JSBridgeUtil.asyncCall('recharge').then((v) => {
        const res = JSON.parse(v)
        if (typeof res === 'object') return res
        else throw ''
      })
    */
    if (await this.isAppVersionHigherThan('4.0.12')) {
      const result: { result: number } = await JSBridgeUtil.asyncCall('buyMember', { channel })
      // {result: 1} 表示充值成功
      console.log(result)
      if (result && result.result === 1) {
        // 充值成功之后页面刷新下
        location.reload()
      }
    } else if (await this.isAppVersionHigherThan('2.0.22')) {
      // 之前的版本直接还是直接充值
      return JSBridgeUtil.asyncCall('recharge').then((v) => {
        const res = JSON.parse(v)
        if (typeof res === 'object') return res
        else throw ''
      })
    } else {
      this.openNativePage('never', undefined, true)
    }
    // 不返回，因为不知道跳跳币数量
    // return { count: 0 } // mock下按之前的接口返回数据
  }

  /**
   * 获得本地地址，配置事件 LocationCallback,获得地区信息
   */
  public static async applyLocation(): Promise<boolean> {
    if (await this.isAppVersionHigherThan('2.0.17')) {
      JSBridgeUtil.asyncCall('getLocation')
      return true
    }
    this.openNativePage('never', undefined, true)
    return false
  }

  public static async canPlayFullScreenVideo(): Promise<boolean> {
    return await this.isAppVersionHigherThan('4.0.22')
  }

  public static async playFullScreenVideo(
    url: string,
    title: string,
    orientation: 'landscape' | 'portrait'
  ): Promise<boolean> {
    // openViewByKey  {"key": "play_video", "url": "xxx","title":"xxx","orientation":"landscape"}
    const result = await JSBridgeUtil.asyncCall('openViewByKey', {
      key: 'play_video',
      url, // 地址
      title, // 标题
      orientation,
    })
    return true
  }

  public static async updateLane() {
    if (await this.isUnderAndroid()) {
      JSBridgeUtil.asyncCall('updateLaneInfo')
    }
  }

  // 保持屏幕常亮 - 体智云APP only
  public static async keepScreenOn(light: boolean) {
    if (await this.isUnderApp()) {
      console.log('keepScreenOn__log:', light)
      JSBridgeUtil.asyncCall('keepScreenLight', {
        light,
      })
    }
  }

  // 获取和设置当前音量 - 体智云APP only
  public static async setAudioVolume(volume: number) {
    if (await this.isUnderApp()) {
      JSBridgeUtil.asyncCall('setAudioVolume', {
        volume, // 0-1的float
      })
    }
  }

  // 获取当前音量 - 体智云APP only
  public static async getAudioVolume(): Promise<number> {
    if (await this.isUnderApp()) {
      const result: { volume: number } = this._parseRespData(await JSBridgeUtil.asyncCall('getAudioVolume'))
      return result.volume
    }
    return -1
  }

  // 音频播放 - 体智云APP only
  public static async playAudio(
    url: string,
    options: {
      onStart?: () => void
      onEnd?: () => void
      onError?: (err: string) => void
    } = {}
  ) {
    if (await this.isUnderApp()) {
      AppUtil._addAppCallListener('onAudioPlayStart', () => {
        options.onStart?.()
      })
      AppUtil._addAppCallListener('onAudioPlayEnd', () => {
        options.onEnd?.()
      })
      AppUtil._addAppCallListener('onAudioPlayError', (err: string) => {
        options.onError?.(err)
      })
      JSBridgeUtil.asyncCall('playAudio', {
        url,
      })
    }
  }

  // 用promise的接口方式实现音频播放
  public static async asyncPlayAudio(
    url: string,
    options: {
      onStart?: () => void
    } = {}
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.playAudio(url, {
        onStart: options.onStart,
        onEnd: () => {
          resolve(true)
        },
        onError: (err: string) => {
          reject(err)
        },
      })
    })
  }

  // 音频播放停止 参考 playAudio - 体智云APP only
  public static async stopAudio(): Promise<void> {
    if (await this.isUnderApp()) {
      await JSBridgeUtil.asyncCall('stopAudio')
    }
  }

  // 生成一个跳转的schema uri
  public static buildOpenSchemaByName(name: AppNativePageName): string {
    return this.buildOpenSchema(AppJumpUtil.buildDictByName(name))
  }

  public static buildOpenSchema(jumpCfg: any): string {
    return `gkid://com.gkid.crazyrope/commonjump?para=${encodeURIComponent(JSON.stringify(jumpCfg))}`
  }

  // 打开app，然后打开内嵌的web页面
  public static buildOpenURLSchema(url: string, title: string): string {
    const jumpCfg = AppJumpUtil.buildOpenURLDict(url, title)
    return this.buildOpenSchema(jumpCfg)
  }

  public static openWechat() {
    if (BrowserUtil.isUnderApp()) {
      AppUtil.startSystemBrowser('weixin://')
    } else {
      location.href = 'weixin://'
    }
  }

  public static openByWebUrl(url: string, title: string) {
    this.open(AppJumpUtil.buildOpenURLDict(url, title))
  }

  public static openByName(name: AppNativePageName): void {
    this.open(AppJumpUtil.buildDictByName(name))
  }

  public static rawOpen(args: any, scheme: string) {
    const fallback = BrowserUtil.isHarmony()
      ? 'https://appgallery.huawei.com/app/detail?id=com.littlelights.crazyrope&channelId=SHARE&source=appshare'
      : 'https://dl.tiantiantiaosheng.com/app/crazyrope/android/crazyrope-latest.apk'
    new CallApp({
      scheme: {
        protocol: scheme,
      },
      appstore: 'http://itunes.apple.com/cn/app/id1531440648',
      timeout: 5000,
      fallback,
    }).open(args)
  }

  // 默认打开首页
  public static open(
    jumpCfg: any = AppJumpUtil.getHomepageConfig(),
    downloadQD?: string,
    tsChannel?: string,
    callBack?: Function
  ): void {
    if (downloadQD) {
      callApp = this.getCallAppOrGotoDL(downloadQD, tsChannel)
    } else {
      callApp = this.getCallApp()
    }
    callApp.open({
      path: 'com.gkid.crazyrope/commonjump',
      param: {
        para: encodeURIComponent(JSON.stringify(jumpCfg)),
      },
      callback: callBack ? callBack() : undefined,
    })
  }

  public static openOrDownloadAppInH5() {
    if (BrowserUtil.isWechat()) {
      this.openOrDownloadAppByYYB()
    } else {
      this.openByWebUrl(location.href, document?.title || '天天跳绳')
    }
  }

  public static openOrDownloadAppByYYB() {
    location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.gkid.crazyrope'
  }

  /**
   * 在外部打开app， 直接打开 或者下载（如果没安装）
   * 如果传递了command，客户端进入首页之后会去解析执行，从而实现从某个活动分享页浏览，点击之后打开或者下载， 然后进入到特定活动的过程
   * eg: 对战完成之后分享给同学， 同学看到之后下载app， 安装完成之后app会直接进入对战逻辑
   *
   * @param jumpCfg 跳转页面配置，参考对应方法
   * @param commandName 构建命令名称
   * @param commandValue 构建命令值
   */
  public static openOrDownloadAppWithCommand(options: _OpenDownloadOption = {}): void {
    const defaultParam = {
      jumpCfg: AppJumpUtil.getHomepageConfig(),
      commandName: '',
      commandValue: '',
      qd: '', // 渠道信息
      tsChannel: '',
    }
    const cfg: _OpenDownloadOption = Object.assign(defaultParam, options)
    if (cfg.commandName || cfg.tsChannel || cfg.qd) {
      // 如果设定cmd，构建之后复制到粘贴板
      // 有tsChannel直接用，否则用qd
      HtmlUtil.copyToClipboardSync(this.buildCommand(cfg.commandName!, cfg.commandValue!, cfg.tsChannel || cfg.qd))
    }
    this.open(cfg.jumpCfg, cfg.qd, cfg.tsChannel)
  }

  public static copyAppCommand(cmd: string, value: string, ts_channel?: string) {
    const appCmd = this.buildCommand(cmd, value, ts_channel)
    HtmlUtil.copyToClipboardSync(appCmd)
    return appCmd
  }

  public static copyAppChannelCommand(ts_channel: string) {
    if (ts_channel) {
      return this.copyAppCommand('', '', ts_channel)
    } else {
      return ''
    }
  }

  // 跳转到native页面
  public static async jump2NativeHomePage(): Promise<void> {
    return this.jump2NativePageByName('homepage')
  }

  public static async jump2NativeMeta(): Promise<void> {
    if (await this.isAppVersionHigherThan('3.0.4')) return JSBridgeUtil.asyncCall('enterCompetitionRoom')
    return this.jump2NativePageByName('meta')
  }

  // 体感派对
  public static async jump2NativeParty() {
    return JSBridgeUtil.asyncCall('enterGatheringRoom')
  }

  // 跳转到unity drill
  public static async jump2UnityDrillGame(drillId: string) {
    const page = AppJumpUtil.buildDictByName('unityJump')
    page.iOS_param = {
      drill_id: drillId,
    }
    page.Android_param = {
      drill_id: drillId,
    }
    return this.jump2NativePage(page)
  }

  public static async jump2NativeFriendPage(): Promise<void> {
    return this.jump2NativePageByName('friends')
  }

  public static async jump2NativeFriendSelector(
    param: {
      h5_title?: string
      h5_url?: string
      h5_img_url?: string
      event_type?: string
      pick_one?: boolean
      activity_id?: string
    } = {}
  ): Promise<void> {
    const page = AppJumpUtil.buildDictByName('FriendSelector')
    page.iOS_param = param
    page.Android_param = param
    page.HarmonyOS_param = param
    return this.jump2NativePage(page)
  }

  public static async jump2NativeGift2Friends(type: number) {
    const page = AppJumpUtil.buildDictByName('gift2Friends')
    page.iOS_param = {
      currentSelectedCardIndex: type,
    }
    page.Android_param = {
      default_index: type,
    }
    return this.jump2NativePage(page)
  }

  public static jump2NativeDrillRank(drillID: string) {
    const page = AppJumpUtil.buildDictByName('drillRank')
    page.iOS_param = {
      defaultDrillID: drillID,
    }
    page.Android_param = {
      drill_id: drillID,
    }

    return this.jump2NativePage(page)
  }

  // 跳转到项目页面
  public static async jump2NativeProjectPage(): Promise<void> {
    return this.jump2NativePageByName('projects')
  }

  // 跳转到native 名人堂
  public static async jump2NativeHallFame(): Promise<void> {
    return this.jump2NativePageByName('hallfame')
  }

  public static async jump2NativePage(jumpCfg: any): Promise<void> {
    // eslint-disable-next-line
    console.log(jumpCfg)
    return JSBridgeUtil.asyncCall('connectHandler', jumpCfg)
  }

  public static async jump2NativeRankAuth(): Promise<void> {
    return this.jump2NativePageByName('rankAuth')
  }

  public static async jump2NativeSetting(): Promise<void> {
    return this.jump2NativePageByName('setting')
  }

  public static async jump2NativeQRCodeScanner(): Promise<void> {
    return this.jump2NativePageByName('qrCodeScanner')
  }

  public static async jump2NativeHomework(): Promise<void> {
    return this.jump2NativePageByName('homeworkHome')
  }

  public static async jump2NativeHomeworkHome(): Promise<void> {
    return this.jump2NativePageByName('homeworkHome')
  }

  public static async jump2NativeHomeworkDetails(_date?: string): Promise<void> {
    if (!(await this.isAppVersionHigherThan('4.0.39'))) {
      this.openNativePage('never', undefined, true)
      return
    }

    const page = AppJumpUtil.buildDictByName('homeworkDetails')

    if (_date) {
      page.iOS_param.targetDateString = _date
      page.Android_param.targetDateString = _date
    }

    return this.jump2NativePage(page)
  }

  public static async jump2NativeHomeworkRank(): Promise<void> {
    return this.jump2NativePageByName('homeworkRank')
  }

  public static async jump2NativeExamTest2021(): Promise<void> {
    return this.jump2NativePageByName('examTest2021')
  }

  public static async jump2NativeLogin(): Promise<void> {
    return this.jump2NativePageByName('login')
  }

  public static async jump2NativeSuperGame(): Promise<void> {
    return this.jump2NativePageByName('superGame')
  }

  public static async jump2NativeRope(): Promise<void> {
    return this.jump2NativePageByName('rope')
  }

  public static async jump2NativeRun(): Promise<void> {
    return this.jump2NativePageByName('running')
  }

  public static async jump2NativeHeartRate(): Promise<void> {
    return this.jump2NativePageByName('heartRate')
  }

  public static async jump2NativeAddFriend(): Promise<void> {
    return this.jump2NativePageByName('AddFriend')
  }

  public static async jump2NativeFitcat(): Promise<void> {
    return this.jump2NativePageByName('fitcat')
  }

  public static async jump2NativeOrderPage(params: any): Promise<void> {
    return this.jump2NativePage({
      ...AppJumpUtil._buildDict((AppJumpUtil.config as any)['order']),
      iOS_param: params,
      Android_param: params,
    })
  }

  public static async jump2NativeOrderDetail(id: string): Promise<void> {
    return this.jump2NativePage({
      ...AppJumpUtil._buildDict((AppJumpUtil.config as any)['orderDetail']),
      iOS_param: { order_id: id },
      Android_param: { id },
    })
  }

  public static async jump2NativePlanDetails(id: string, name: string): Promise<void> {
    return this.jump2NativePage({
      ...AppJumpUtil.buildDictByName('planDetails'),
      iOS_param: { plan_id: id, plan_name: name },
      Android_param: { id },
    })
  }

  public static async jump2NativeDrillDetails(id: string) {
    return this.jump2NativePage({
      ...AppJumpUtil.buildDictByName('drillDetails'),
      iOS_param: { drill_id: id },
      Android_param: { 'extra.drill': id },
    })
  }

  public static async jump2NativeGroupChat(_id: string, _name: string) {
    if (!(await this.isAppVersionHigherThan('4.0.55'))) {
      this.openNativePage('never', undefined, true)
      return
    }

    return this.jump2NativePage({
      ...AppJumpUtil.buildDictByName('groupChat'),
      iOS_param: {
        group_id: _id,
        group_name: _name,
      },
      Android_param: {
        GROUP_ID: _id,
        GROUP_NAME: _name,
      },
      HarmonyOS_param: {
        group_id: _id,
        group_name: _name,
      },
    })
  }

  public static async jump2NativeActivityHome() {
    if (!(await this.isAppVersionHigherThan('4.0.55'))) {
      this.openNativePage('never', undefined, true)
      return
    }

    return this.jump2NativePageByName('activityHome')
  }

  public static async jump2NativePay(orderId: string, scene?: string) {
    return this.jump2NativePage({
      ...AppJumpUtil.buildDictByName('pay'),
      iOS_param: { order_id: orderId, activity_scene: scene },
      Android_param: { order_id: orderId, activity_scene: scene },
    })
  }

  public static async jump2NativeDrillCourse() {
    return this.jump2NativePageByName('drillCourse')
  }

  public static async jump2NativeSportsCourseDetails(_planId: string, _planInstanceId: string, _dayPos: number) {
    const params = {
      plan_id: _planId,
      plan_inst_id: _planInstanceId,
      day_pos: _dayPos,
    }

    return this.jump2NativePage({
      ...AppJumpUtil.buildDictByName('sportsCourseDetails'),
      iOS_param: params,
      Android_param: params,
    })
  }

  public static async jump2NativeSportsCourseLanding(_planId: string, _fromId = 'tzy_student', _sceneId1?: string) {
    const params: any = {
      planId: _planId,
      fromId: _fromId,
    }

    if (_sceneId1) {
      params.scene_id1 = _sceneId1
    }

    return this.jump2NativePage({
      ...AppJumpUtil.buildDictByName('sportsCourseLanding'),
      iOS_param: params,
      Android_param: params,
    })
  }

  public static async jump2NativePageByName(_name: AppNativePageName): Promise<void> {
    return this.jump2NativePage(await this.buildDictByName(_name))
  }

  public static async jump2NativePageByCfg(cfg: any): Promise<void> {
    return this.jump2NativePage(AppJumpUtil._buildDict(cfg))
  }

  // 跳转到原生app的页面, 原生内部调用jsbridge 区别于用schema打开
  public static async jump2NativeURL(url: string, title?: string): Promise<void> {
    const jumpCfg = AppJumpUtil.buildOpenURLDict(url, title)
    return this.jump2NativePage(jumpCfg)
  }

  // APP功能统一调用方法
  public static async openNativePage(key: string, data?: { [k: string]: any }, showUpdate = false): Promise<boolean> {
    return JSBridgeUtil.asyncCall('openViewByKey', { key, data, showUpdate })
  }

  public static async checkNativePage<T>(keys: (keyof T)[]): Promise<Record<keyof T, boolean>> {
    return JSBridgeUtil.asyncCall('checkViewKey', keys)
  }

  // 提醒开启订阅
  public static async subscribe() {
    JSBridgeUtil.asyncCall('subscribe')
  }

  public static async phoneVerified() {
    try {
      JSBridgeUtil.asyncCall('phoneVerified')
    } catch (e) {
      // noop
    }
  }

  public static downloadFile(url: string, name = 'download.png') {
    const a = document.createElement('a')
    a.setAttribute('href', url)
    a.setAttribute('download', name)
    a.setAttribute('target', '_blank')
    // const clickEvent = document.createEvent('MouseEvents');
    // clickEvent.initEvent('click', true, true);
    // a.dispatchEvent(clickEvent);
    a.click()
    return
  }

  public static downloadFileByBlob(blob: Blob, name: string) {
    const url = URL.createObjectURL(blob)
    return this.downloadFile(url, name)
  }

  public static dataURLtoBlob(dataurl: string) {
    const arr = dataurl.split(',')
    const mime = (arr[0].match(/:(.*?);/) || [])[1]
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new Blob([u8arr], { type: mime })
  }

  public static async downloadImgByBase64(base64: string, name: string) {
    const myBlob = this.dataURLtoBlob(base64)
    return this.downloadFileByBlob(myBlob, name)
  }

  // 增加时间回调
  public static async _addAppCallListener(eventName: string, callback: any) {
    if (await this.isUnderApp()) {
      // eslint-disable-next-line no-console
      console.log(`start app event listen ${eventName}`)
      JSBridgeUtil.registerHandler(eventName, callback)
    }
  }

  public static async appendToken2Header(headers: any): Promise<any> {
    return this._appendToken2Header(headers)
  }

  public static async getAppOrH5Token(): Promise<any> {
    if (await this.isUnderApp()) {
      return await this.getUserToken()
    } else {
      return StorageUtil.get(this.buildRequestTokenKey()) || ''
    }
  }

  public static async _appendToken2Header(headers: any): Promise<any> {
    if (!requestToken) {
      if (await this.isUnderApp()) {
        requestToken = await this.getUserToken()
      } else {
        requestToken = StorageUtil.get(this.buildRequestTokenKey()) || ''
      }
    }

    if (requestToken) {
      headers.Authorization = `bearer ${requestToken}`
    }

    return headers
  }

  public static async _appendRequestHeaders(_headers: Record<string, string>, _appendDeviceInfo = false) {
    let headers = await this._appendToken2Header(_headers)

    if (_appendDeviceInfo) {
      headers = await this._appendDeviceInfoHeaders(headers)
    }

    return headers
  }

  public static async _appendDeviceInfoHeaders(_headers: Record<string, string>) {
    if ((await this.isUnderApp()) && (await this.isAppVersionHigherThan('4.0.73'))) {
      const deviceInfo = await this.getDeviceInfo()

      return deviceInfo
        ? {
            ...(_headers || {}),
            ['X-Gkid-flavor']: deviceInfo['X-Gkid-flavor'],
            ['X-Gkid-appVersion']: deviceInfo['X-Gkid-appVersion'],
            ['X-Gkid-deviceName']: deviceInfo['X-Gkid-deviceName'],
          }
        : _headers
    }

    return _headers
  }

  public static _checkIsNeedAppendDeviceInfo(_url: string) {
    return !!(
      process.env.VUE_APP_CRAZYROPE_API && HttpUtil.buildFullUrl(_url).startsWith(process.env.VUE_APP_CRAZYROPE_API)
    )
  }

  public static _getCurrentRequestToken(): string {
    return requestToken
  }

  public static getCallApp(): CallApp {
    if (!callApp) {
      const fallback = BrowserUtil.isHarmony()
        ? 'https://appgallery.huawei.com/app/detail?id=com.littlelights.crazyrope&channelId=SHARE&source=appshare'
        : 'https://dl.tiantiantiaosheng.com/app/crazyrope/android/crazyrope-latest.apk'
      callApp = new CallApp({
        scheme: {
          protocol: 'gkid',
        },
        appstore: 'http://itunes.apple.com/cn/app/id1531440648',
        timeout: 3000,
        fallback,
      })
    }

    return callApp
  }

  public static getCallAppOrGotoDL(qd: string, tsChannel?: string): CallApp {
    const downloadUrl = StringUtil.appendQueryString2Url(
      `https://www.tiantiantiaosheng.com/dl`,
      StringUtil.buildQueryString({ qd, ts_channel: tsChannel ? tsChannel : '' })
    )
    if (!callApp) {
      callApp = new CallApp({
        scheme: {
          protocol: 'gkid',
        },
        appstore: downloadUrl,
        timeout: 3000,
        fallback: downloadUrl,
      })
    }

    return callApp
  }

  public static getDownloadUrl() {
    let baseUrl = `https://www.tiantiantiaosheng.com/dl`
    if (!EnvUtil.isProd()) {
      baseUrl = `https://www-test.tiantiantiaosheng.com/dl`
    }
    return baseUrl
  }

  public static buildDownloadUrl(qd: string, ts_channel: string, cfg?: { baseUrl?: string; query?: any }): string {
    // 构建下载页面地址, 会补上渠道信息qd和 channel信息 （channel带有渠道和用户信息）
    let baseUrl = cfg && cfg.baseUrl ? cfg.baseUrl : ''
    const queryObj = cfg && cfg.query ? cfg.query : {}
    if (!baseUrl) {
      baseUrl = this.getDownloadUrl()
    }
    if (qd) {
      queryObj.qd = qd
    }
    if (ts_channel) {
      queryObj.ts_channel = ts_channel
    }
    if (baseUrl.includes('?')) {
      baseUrl = baseUrl + '&' + StringUtil.buildQueryString(queryObj)
    } else {
      baseUrl = baseUrl + '?' + StringUtil.buildQueryString(queryObj)
    }
    return baseUrl
  }

  public static buildCommand(name: string, value: string | number, qd = ''): string {
    // 构建一个命令，如果带有渠道，会拼成多命令内容
    let result = this._buildSingleCmd(name, value)
    if (qd) {
      // result 可能为空, 判断 _SplitMultiCmd
      result = `${result}${result ? '&' : ''}${this._buildSingleCmd(this.AppOpenCmd.qudao, qd)}`
    }
    // 除了两个老命令其他都加上前缀
    const commandPrefix = this.AppOpenCmd._IosCommandPrefix
    // if (this.AppOpenCmd._OldCmds.includes(name) && !!value) {
    //   commandPrefix = ''
    // }
    return `${commandPrefix}${result}`
  }

  public static _buildSingleCmd(cmd: string, value: string | number): string {
    // 构建单个简单命令
    if (!cmd || !value) {
      return ''
    }
    if (cmd === this.AppOpenCmd.qudao) {
      return `ts_channel=${value}`
    } else {
      return `mode=${this.AppOpenCmd._CmdPrefix}${cmd}&token=${value}`
    }
  }

  public static _parseRespData(result: any) {
    try {
      if (result) {
        return JSON.parse(result)
      }
    } catch (e) {
      // eslint-disable-next-line
      console.error(e)
    }
    return {}
  }

  public static async videoEventCall(eventName: 'play' | 'ended' | 'pause', videoUrl: string): Promise<any> {
    return JSBridgeUtil.asyncCall('videoEvent', {
      event: eventName,
      videoUrl,
    })
  }

  // ================ app 主动调用事件 ================
  public static setStopVideoPlayListener() {
    this._addAppCallListener('pauseVideo', () => {
      // eslint-disable-next-line no-console
      console.log('stopVideoEvevnt')
      const videos = document.getElementsByTagName('video')
      for (const v of videos) {
        const ele = v as HTMLVideoElement
        ele.pause()
      }
    })
  }

  public static addReminder(_params: IAppReminderParams) {
    return JSBridgeUtil.asyncCall('addReminder', {
      ..._params,
      startDate: _params.startDate.getTime(),
      endDate: _params.endDate.getTime(),
    })
  }

  public static enterPKRoom(_params: {
    scene: string
    game_group: string
    round_score: number
    cheered_count: number
  }) {
    return JSBridgeUtil.asyncCall('enterChampionRoom', _params)
  }

  public static enterRunning(
    _params: {
      event_type: string
      event_id: string
      max_distance_per_day: number
      min_distance_per_time: number
      min_speed: null | number
      max_speed: number
    },
    cb?: Function
  ) {
    if (cb) {
      this._addAppCallListener('schoolRunCallback', cb)
    }

    return JSBridgeUtil.asyncCall('enterSchoolRunPage', _params)
  }

  public static recordOpen(_params: {}, cb?: Function) {
    if (cb) {
      this._addAppCallListener('recordAllowCallback', cb)
    }
    return JSBridgeUtil.asyncCall('recordOpen', _params)
  }

  public static recordStart(_params: {}, cb?: Function) {
    if (cb) {
      this._addAppCallListener('recordTextCallback', cb)
    }
    return JSBridgeUtil.asyncCall('recordStart', _params)
  }
  public static drillPlayReciveRegist(cb?: Function) {
    if (cb) {
      this._addAppCallListener('drillPlayCallback', cb)
    }
  }
  public static drillPlaySend(_params: IIntelligentClassDrillMsg) {
    return JSBridgeUtil.asyncCall('drillPlay', _params)
  }
  public static socketOpen(
    _params: {
      url: string
      room_id: string
      group_name: string
      to_group_name: string[]
      protocols: string[]
    },
    cb?: Function
  ) {
    if (cb) {
      this._addAppCallListener('socketOpenCallback', cb)
    }
    return JSBridgeUtil.asyncCall('socketOpen', _params)
  }
  public static socketClose(cb?: Function) {
    if (cb) {
      this._addAppCallListener('socketCloseCallback', cb)
    }
    return JSBridgeUtil.asyncCall('socketClose', {})
  }
  public static socketMsgReceive(cb?: Function) {
    if (cb) {
      this._addAppCallListener('socketMsgReceiveCallback', (respStr: string) => cb(this._parseRespData(respStr)))
    }
  }
  public static socketMsgSend(_params: IIntelligentClassSocketMsg, cb?: Function) {
    if (cb) {
      this._addAppCallListener('socketMsgSendCallback', cb)
    }
    return JSBridgeUtil.asyncCall('socketMsgSend', _params)
  }
  public static async preloadDrillsResource(
    _params: {
      drill_ids: string[]
    },
    cb?: Function
  ): Promise<{}> {
    if (cb) {
      this._addAppCallListener('preloadDrillsResourceCallback', cb)
    }
    return JSBridgeUtil.asyncCall('preloadDrillsResource', _params)
  }

  public static recordStop(_params: {}) {
    return JSBridgeUtil.asyncCall('recordStop', _params)
  }

  // 语音唤醒服务
  public static audioWakeupStart(
    _params: {
      PARAM_KEYWORD?: string //多个唤醒词用“,”分割
      PARAM_THRESHOLD?: number //唤醒灵敏度，越低越灵敏
      loop?: boolean //默认false, 单词唤醒
      PARAM_SINGLE?: boolean // 默认false，true的时候唤醒后自动关闭
    },
    cb?: Function // params: json string as IAudioWakeupCallbackParams
  ) {
    if (cb) {
      this._addAppCallListener('wakeupCallback', cb)
    }
    return JSBridgeUtil.asyncCall('wakeupStart', _params)
  }

  // 停止语音唤醒服务
  public static audioWakeupStop() {
    return JSBridgeUtil.asyncCall('wakeupStop')
  }

  // profile // 音色
  // len // 出现多少字之后开始提供给tts说话， 默认20
  public static audioSet(_params: { profile?: string; len?: number }) {
    return JSBridgeUtil.asyncCall('audioSet', _params)
  }

  public static audioStart(_params: {}, cb?: Function, cb1?: Function) {
    if (cb) {
      this._addAppCallListener('audioStartCallback', cb)
    }
    if (cb1) {
      this._addAppCallListener('audioEndCallback', cb1)
    }
    return JSBridgeUtil.asyncCall('audioStart', _params)
  }

  public static audioAdd(_params: { text: string; isFinal: boolean }) {
    return JSBridgeUtil.asyncCall('audioAdd', _params)
  }

  public static audioPause(_params: {}) {
    return JSBridgeUtil.asyncCall('audioPause', _params)
  }

  public static audioResume(_params: {}) {
    return JSBridgeUtil.asyncCall('audioResume', _params)
  }

  public static audioStop(_params: {}) {
    return JSBridgeUtil.asyncCall('audioStop', _params)
  }

  public static readonly VirtualRoom = {
    JumpRope: 'jump_rope', // 跳绳房
    Defend: 'defend', // 保卫运动场
  }

  /**
   * 进入对应的运动房, 注意 sports_room_list 是房间列表
   * @param _params jump_rope 跳绳房
   */
  public static enterVirtualRoom(_params: { scene: string }) {
    return JSBridgeUtil.asyncCall('enterVirtualRoom', _params)
  }

  // 体感派对
  public static enterGatheringRoom() {
    return JSBridgeUtil.asyncCall('enterGatheringRoom')
  }

  /** 【体智云】调起 App 摄像头直播（RTC 房间），rtcRoomCloseCallback，会在页面becomeActive事件之后调用 */
  public static startRtcRoom(_params: IStartRtcRoomParams, _rtcRoomCloseCallback?: () => void) {
    if (_rtcRoomCloseCallback) {
      this._addAppCallListener('rtcRoomCloseCallback', _rtcRoomCloseCallback)
    }
    return JSBridgeUtil.asyncCall('startRtcRoom', _params)
  }

  // 通过人民币购买(通常是会员，区别于虚拟物品)，弹出原生半弹窗，购买成功之后会有返回值true
  public static async buySkuPopup(skuCode: string): Promise<boolean> {
    return this.applePay(skuCode)
  }

  // 购买会员
  public static async purchase(_skuCode: string, _params: IAppPurchaseParams = {}) {
    const params = {
      refer: 'h5',
      ..._params,
    }

    if (await AppUtil.isAppVersionHigherThan('4.0.65')) {
      return JSBridgeUtil.asyncCall('purchaseItemV2', {
        sku_code: _skuCode,
        ...params,
      }).then((res) => !!res)
    }

    return AppUtil.applePay(_skuCode)
  }

  public static async applePay(skuCode: string): Promise<boolean> {
    if ((await this.isUnderIos()) && !(await this.isAppVersionHigherThan('3.0.47'))) {
      const result = await this.httpGET(`${process.env.VUE_APP_PAY_API}/payment/order/product_everyday_payment_limit`, {
        sku_code: skuCode,
      })

      if (result.be_limited) {
        return UIUtil.checkFailed(result.msg)
      }
    }

    if ((await this.isUnderAndroid()) && !(await this.isAppVersionHigherThan('3.0.7'))) {
      return this.openNativePage('never', undefined, true)
    }

    return JSBridgeUtil.asyncCall('purchaseItem', skuCode).then((res) => !!res)
  }

  public static async androidPay(skuCode: string, title: string, desc: string, offerId: string) {
    return JSBridgeUtil.asyncCall('purchaseItem', {
      title,
      desc,
      skuCode,
      offerId,
    })
  }

  public static async chatWithFriend(_friendId: string) {
    return JSBridgeUtil.asyncCall('startFriendMessageChat', { friend_id: _friendId })
  }

  public static async chatWithClazz(groupId: string) {
    return JSBridgeUtil.asyncCall('enterClassSportGroupView', { groupId: `class_${groupId}` })
  }

  public static async registerBackInterceptor(_interceptor: (_params: IBackInterceptorParams) => Promise<boolean>) {
    const backInterceptor = 'backInterceptor'
    JSBridgeUtil.asyncCall('setConfig', { backInterceptor })
    AppUtil._addAppCallListener(backInterceptor, (_params: IBackInterceptorParams, _cb: any) => {
      _interceptor(AppUtil._parseRespData(_params)).then((_res) => {
        _res && _cb?.()
      })
    })
  }

  /**
   * 通用的让app打开页面的逻辑
   * 如果在app内，则打开页面
   * 否则目前ios通过univeral link的方式会直接打开app并打开页面
   * android会通过schema打开页面（微信里会让打开浏览器，ios微信也能直接打开）
   * 后续看看能否通过应用宝直接打开
   * @param url 需要打开的url
   */
  public static async universalOpenUrlInApp(url = location.href, title = document.title || '天天跳绳', qd = '') {
    if (await this.isUnderApp()) {
      // app内直接打开
      if (location.href !== url) {
        this.openByWebUrl(url, title)
      }
    } else {
      location.href = `${this.getDownloadUrl()}?cr_type=h5&cr_url=${encodeURIComponent(url)}&qd=${qd}`
    }
  }

  public static buildMatchUrl(path: string, prefix = '/api'): string {
    if (EnvUtil.isProd()) {
      return `https://api-match.tiantiantiaosheng.com${prefix}${path}`
    } else {
      return `https://api-match-test.tiantiantiaosheng.com${prefix}${path}`
    }
  }

  public static buildMatchH5Url(path: string): string {
    let envPrefix = '-test'
    if (EnvUtil.isProd()) {
      envPrefix = ''
    }
    return `https://www${envPrefix}.tiantiantiaosheng.com/apph5/#${path}`
  }

  // 构建访问比赛的页面
  public static buildMatchRankUrl(matchId: string): string {
    return this.buildMatchH5Url(`/online-matches/v2/${matchId}/rank`)
  }

  public static buildMatchFinalScoreUrl(matchId: string, schoolId: string | number): string {
    return this.buildMatchH5Url(`/online-matches/v2/${matchId}/final-school-score?schoolId=${schoolId}`)
  }

  public static buildOssVideoThumbnail(ossVideoUrl: string, offsetMillSeconds = 1000) {
    return `${ossVideoUrl}?x-oss-process=video/snapshot,t_${offsetMillSeconds},m_fast`
  }
}
